import { useMemo } from 'react'

import { Currency, useQuery } from '@sequencehq/api'
import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'
import { HOURS } from '@sequencehq/utils/dates'

export type CurrencyOption = { label: string; value: Currency }

/**
 * Returns the account's enabled currencies as `{ label, value }` options where
 * the label is always the 3-letter ISO code (e.g. `'USD'`, `'EUR'`). Shared by
 * the switch's currency property selector and the unit selector so both render
 * identically.
 */
export const useCurrencyOptions = (): CurrencyOption[] => {
  const { data: enabledCurrencies } = useQuery(
    dashboard20240730Client.getSequenceAccountSettings,
    undefined,
    {
      staleTime: 1 * HOURS,
      select: data => data?.enabledCurrencies
    }
  )

  return useMemo(
    () =>
      (enabledCurrencies ?? []).map((currency: Currency) => ({
        label: currency,
        value: currency
      })),
    [enabledCurrencies]
  )
}
